import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import get from 'lodash/get';
import {
    DEPRECATED,
    slate30,
    white,
} from '@zocdoc-mezzanine/foundations-colors';
import { Link } from '@zocdoc-frontend-common/components-link';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { MobileTimeslotsViewWrapper } from '@zocdoc-frontend-common/components-timesgrid';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import TimesGridWithTooltip from './TimesGridWithTooltip';
import { BookingStateProperties } from '../../constants';
import bookingStateSelector from '../../selectors/BookingStateSelector';

export const BaseAppointmentTimeBlock = ({
    directoryId,
    formattedAppointmentTime,
    insuranceCarrierId,
    insurancePlanId,
    isMobile,
    isNewPatient,
    isReschedule,
    locationCloudId,
    locationId,
    onEditClick,
    onTimeSlotClicked,
    procedureId,
    providerCloudId,
    providerId,
    showTimesGrid,
    hasAppointmentTimeError,
}) => {
    if (showTimesGrid) {
        return (
            <TimesGridWrapper>
                <TimesGridWithTooltip
                    directoryId={directoryId}
                    insuranceCarrierId={insuranceCarrierId}
                    insurancePlanId={insurancePlanId}
                    isMobile={isMobile}
                    isNewPatient={isNewPatient}
                    isReschedule={isReschedule}
                    locationCloudId={locationCloudId}
                    locationId={locationId}
                    onTimeSlotClicked={onTimeSlotClicked}
                    procedureId={procedureId}
                    providerCloudId={providerCloudId}
                    providerId={providerId}
                    hasAppointmentTimeError={hasAppointmentTimeError}
                />
            </TimesGridWrapper>
        );
    } else {
        return (
            <AppointmentTimeSummaryWrapper hasError={hasAppointmentTimeError}>
                <AppointmentTime
                    data-test="appointment-time-wrapper"
                    data-uem-id="appointment-time"
                >
                    {formattedAppointmentTime}
                </AppointmentTime>
                <EditButton
                    data-test="edit-appointment-button"
                    data-uem-id={`edit-appointment-button-${
                        isMobile ? 'mobile' : 'desktop'
                    }`}
                    onClick={onEditClick}
                >
                    Edit
                </EditButton>
            </AppointmentTimeSummaryWrapper>
        );
    }
};

BaseAppointmentTimeBlock.propTypes = {
    formattedAppointmentTime: PropTypes.string,
    isMobile: PropTypes.bool,
    isNewPatient: PropTypes.bool,
    locationId: PropTypes.string,
    onEditClick: PropTypes.func,
    onTimeSlotClicked: PropTypes.func,
    procedureId: PropTypes.string,
    providerId: PropTypes.string,
    showTimesGrid: PropTypes.bool,
    hasAppointmentTimeError: PropTypes.bool,
};

const MOBILE_PADDING_RIGHT = 16;

const TimesGridWrapper = styled.div`
    background-color: ${white};
    padding: 12px ${MOBILE_PADDING_RIGHT}px 24px;

    ${breakpoint.small} {
        padding-left: 0;
        padding-right: 0;
    }

    ${MobileTimeslotsViewWrapper} {
        margin-right: -${MOBILE_PADDING_RIGHT}px;
    }
`;

const AppointmentTimeSummaryWrapper = styled.div`
    align-items: center;
    background-color: ${white};
    border: 1px solid ${p => (p.hasError ? DEPRECATED.tertiaryCoral : slate30)};
    display: flex;
    flex-direction: row;
    height: 48px;
    justify-content: space-between;
    padding: 0 16px;
`;

const EditButton = styled(Link)`
    cursor: pointer;
    font: 15px/24px ${FontFamily.SharpSansSemibold};
`;

const AppointmentTime = styled.span`
    font: 15px/28px ${FontFamily.SharpSansSemibold};
    padding-top: 1px;
    padding-bottom: 3px;
`;

const mapStateToProps = state => {
    const bookingState = bookingStateSelector(state);
    return {
        locationCloudId: get(
            bookingState,
            BookingStateProperties.locationCloudId
        ),
        providerCloudId: get(
            bookingState,
            BookingStateProperties.providerCloudId
        ),
    };
};

export default connect(mapStateToProps)(BaseAppointmentTimeBlock);
